import { Centrifuge } from 'centrifuge';

import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';

import setRealtimeOfflineStatus from './helpers/setRealtimeOfflineStatus';
import Sockets from './sockets';
import { DISCONNECTION_CODES } from './helpers/disconnectionCodes';

export default (callback, options = {}) => {
  const defaultOptions = {
    isTesting: false,
    socketConnectionToken: window.gon?.socket_connection_token,
    socketConnectionUrl: window.gon?.socket_connection_url,
    subscriptionEndpoint: `${window.location.protocol}//${window.location.host}/api/channels`,
    subscriptionHeaders: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const finalOptions = merge({}, defaultOptions, options);

  const {
    isTesting,
    socketConnectionUrl,
    socketConnectionToken,
    subscriptionEndpoint,
    subscriptionHeaders,
  } = finalOptions;

  Sockets.subscriptionEndpoint = subscriptionEndpoint;
  Sockets.subscriptionHeaders = subscriptionHeaders;

  if (isTesting) {
    Sockets.isConnected = true;
    Sockets.connection = { subscribe: () => ({ bind: () => {} }) };
    Sockets.connectionAt = new Date();
    Sockets.channels = {};
    callback();
    return;
  }

  if (!Sockets.isConnected) {
    const centrifuge = new Centrifuge(`${socketConnectionUrl}/connection/websocket`, {
      debug: true,
      timeout: 15000,
      onTransportClose() {
        Sockets.reconnectionAttempts += 1;

        if (Sockets.reconnectionAttempts > 10) {
          centrifuge._reconnect = false;

          window.onfocus = window.location.reload();

          console.log('Centrifugo has attempted to reconnect 10 times at ', new Date());
        }
      },
    });

    centrifuge.setToken(socketConnectionToken);

    const handleInitialConnection = (context) => {
      Sockets.connection = centrifuge;

      if (callback) callback();

      console.log('Centrifugo Sockets connected', context, 'at ', new Date());
    };

    const handleReconnection = (context) => {
      Sockets.reconnectionAttempts = 0;
      Sockets.disconnectedAt = null;

      setRealtimeOfflineStatus(false);

      console.log('Centrifugo Sockets reconnected', context, 'at ', new Date());
    };

    const handleDisconnection = (context) => {
      Sockets.isConnected = false;
      Sockets.disconnectedAt = new Date();

      setRealtimeOfflineStatus(true);

      console.log('Sockets disconnected', context, 'at ', new Date());
    };

    const handleError = (context) => {
      const isDisconnection = DISCONNECTION_CODES.includes(context.error?.code);

      if (isDisconnection) {
        handleDisconnection(context);
      } else {
        console.error('Centrifugo Sockets error', context, 'at ', new Date());
      }
    };

    centrifuge.on('connected', (context) => {
      Sockets.isConnected = true;
      Sockets.connectedAt = new Date();

      const isReconnection = !isEmpty(Sockets.connection);
      if (isReconnection) {
        handleReconnection(context);
      } else {
        handleInitialConnection(context);
      }
    });

    centrifuge.on('disconnected', handleDisconnection);
    centrifuge.on('error', handleError);

    centrifuge.connect();
  }
};
